// extracted by mini-css-extract-plugin
module.exports = {"MainLayout":"Main_MainLayout__01o6e"};